// Legal content (Terms + Legal notice) per language. English is the fallback.
const CONTACT = "gaimtimeapp@gmail.com";

export const legalContent = {
  fr: {
    cgv_title: "Conditions Générales de Vente",
    legal_title: "Mentions Légales",
    updated: "Dernière mise à jour : juillet 2026. Document type à faire valider par un professionnel du droit.",
    cgv: [
      { t: "1. Objet", b: "Les présentes CGV régissent la vente des services GaimTime, application web de compression du temps de travail." },
      { t: "2. Offres et prix", b: "Accès à vie : paiement unique de 4,99 € TTC. GaimTime Coach & Compagnon : abonnement de 9,99 € TTC/mois. Prix TTC (TVA 20 %)." },
      { t: "3. Paiement", b: "Paiements sécurisés par Stripe. Aucune donnée bancaire n'est stockée. Une facture PDF est fournie après chaque paiement." },
      { t: "4. Droit de rétractation", b: "L'accès immédiat au service numérique après paiement entraîne la renonciation au droit de rétractation de 14 jours." },
      { t: "5. Résiliation", b: "L'abonnement mensuel peut être résilié à tout moment ; l'effet intervient à la fin de la période en cours, sans remboursement du mois entamé." },
      { t: "6. Contact", b: `Pour toute question : ${CONTACT}.` },
    ],
    legal: [
      { t: "Éditeur", b: `Le service GaimTime est édité par son exploitant. Contact : ${CONTACT}.` },
      { t: "Hébergement", b: "Application hébergée sur une infrastructure cloud sécurisée (base MongoDB et stockage d'objets)." },
      { t: "Propriété intellectuelle", b: "La marque GaimTime, le logo, le design et le code sont protégés. Toute reproduction non autorisée est interdite." },
      { t: "Données personnelles (RGPD)", b: `Vos données servent uniquement à fournir le service et personnaliser le coach. Droit d'accès, de rectification et de suppression via ${CONTACT}. Jamais revendues.` },
      { t: "Notifications", b: "Les notifications push (rappels de fin de journée) ne sont envoyées qu'avec votre consentement et sont désactivables à tout moment." },
      { t: "Cookies et stockage local", b: "GaimTime utilise le stockage local pour la session. Aucun cookie publicitaire." },
    ],
  },
  en: {
    cgv_title: "Terms & Conditions",
    legal_title: "Legal Notice",
    updated: "Last updated: July 2026. Template document to be reviewed by a legal professional.",
    cgv: [
      { t: "1. Purpose", b: "These terms govern the sale of GaimTime services, a web app for compressing work time." },
      { t: "2. Offers and pricing", b: "Lifetime access: one-time payment of €4.99 incl. tax. GaimTime Coach & Companion: €9.99/mo incl. tax. Prices include 20% VAT." },
      { t: "3. Payment", b: "Payments are secured by Stripe. No card data is stored. A PDF invoice is provided after each payment." },
      { t: "4. Right of withdrawal", b: "Immediate access to the digital service after payment entails waiving the 14-day right of withdrawal." },
      { t: "5. Cancellation", b: "The monthly subscription can be cancelled anytime; it ends at the close of the current period, with no refund for the started month." },
      { t: "6. Contact", b: `For any question: ${CONTACT}.` },
    ],
    legal: [
      { t: "Publisher", b: `The GaimTime service is published by its operator. Contact: ${CONTACT}.` },
      { t: "Hosting", b: "The app is hosted on secure cloud infrastructure (MongoDB database and object storage)." },
      { t: "Intellectual property", b: "The GaimTime brand, logo, design and code are protected. Any unauthorized reproduction is prohibited." },
      { t: "Personal data (GDPR)", b: `Your data is used only to provide the service and personalize the coach. Access, rectification and deletion rights via ${CONTACT}. Never resold.` },
      { t: "Notifications", b: "Push notifications (end-of-day reminders) are sent only with your consent and can be disabled anytime." },
      { t: "Cookies and local storage", b: "GaimTime uses local storage for your session. No advertising cookies." },
    ],
  },
  es: {
    cgv_title: "Términos y Condiciones",
    legal_title: "Aviso Legal",
    updated: "Última actualización: julio de 2026. Documento tipo a validar por un profesional del derecho.",
    cgv: [
      { t: "1. Objeto", b: "Estos términos rigen la venta de los servicios GaimTime, una app web para comprimir el tiempo de trabajo." },
      { t: "2. Ofertas y precios", b: "Acceso de por vida: pago único de 4,99 € IVA incl. GaimTime Coach & Compañero: 9,99 €/mes IVA incl. Precios con IVA del 20%." },
      { t: "3. Pago", b: "Pagos asegurados por Stripe. No se almacenan datos bancarios. Se entrega una factura PDF tras cada pago." },
      { t: "4. Derecho de desistimiento", b: "El acceso inmediato al servicio digital tras el pago conlleva la renuncia al derecho de desistimiento de 14 días." },
      { t: "5. Cancelación", b: "La suscripción mensual puede cancelarse en cualquier momento; finaliza al término del período en curso, sin reembolso del mes iniciado." },
      { t: "6. Contacto", b: `Para cualquier consulta: ${CONTACT}.` },
    ],
    legal: [
      { t: "Editor", b: `El servicio GaimTime es editado por su operador. Contacto: ${CONTACT}.` },
      { t: "Alojamiento", b: "La app se aloja en infraestructura cloud segura (base MongoDB y almacenamiento de objetos)." },
      { t: "Propiedad intelectual", b: "La marca GaimTime, el logo, el diseño y el código están protegidos. Prohibida su reproducción no autorizada." },
      { t: "Datos personales (RGPD)", b: `Tus datos solo sirven para prestar el servicio y personalizar el coach. Derechos de acceso, rectificación y supresión vía ${CONTACT}. Nunca se revenden.` },
      { t: "Notificaciones", b: "Las notificaciones push (recordatorios de fin de día) se envían solo con tu consentimiento y pueden desactivarse." },
      { t: "Cookies y almacenamiento local", b: "GaimTime usa el almacenamiento local para la sesión. Sin cookies publicitarias." },
    ],
  },
  de: {
    cgv_title: "Allgemeine Geschäftsbedingungen",
    legal_title: "Impressum",
    updated: "Letzte Aktualisierung: Juli 2026. Musterdokument, von einem Rechtsexperten zu prüfen.",
    cgv: [
      { t: "1. Zweck", b: "Diese AGB regeln den Verkauf der GaimTime-Dienste, einer Web-App zur Verdichtung der Arbeitszeit." },
      { t: "2. Angebote und Preise", b: "Lebenslanger Zugang: Einmalzahlung 4,99 € inkl. GaimTime Coach & Begleiter: 9,99 €/Monat inkl. Preise inkl. 20% MwSt." },
      { t: "3. Zahlung", b: "Zahlungen werden durch Stripe gesichert. Keine Kartendaten gespeichert. Nach jeder Zahlung wird eine PDF-Rechnung bereitgestellt." },
      { t: "4. Widerrufsrecht", b: "Der sofortige Zugang zum digitalen Dienst nach Zahlung bewirkt den Verzicht auf das 14-tägige Widerrufsrecht." },
      { t: "5. Kündigung", b: "Das Monatsabo ist jederzeit kündbar; es endet zum Ablauf der laufenden Periode, ohne Erstattung des begonnenen Monats." },
      { t: "6. Kontakt", b: `Bei Fragen: ${CONTACT}.` },
    ],
    legal: [
      { t: "Anbieter", b: `Der Dienst GaimTime wird von seinem Betreiber herausgegeben. Kontakt: ${CONTACT}.` },
      { t: "Hosting", b: "Die App wird auf sicherer Cloud-Infrastruktur gehostet (MongoDB-Datenbank und Objektspeicher)." },
      { t: "Geistiges Eigentum", b: "Marke GaimTime, Logo, Design und Code sind geschützt. Unbefugte Vervielfältigung ist untersagt." },
      { t: "Personenbezogene Daten (DSGVO)", b: `Ihre Daten dienen nur der Bereitstellung des Dienstes und der Personalisierung des Coaches. Auskunft, Berichtigung und Löschung über ${CONTACT}. Kein Weiterverkauf.` },
      { t: "Benachrichtigungen", b: "Push-Benachrichtigungen (Tagesend-Erinnerungen) werden nur mit Ihrer Zustimmung gesendet und sind jederzeit deaktivierbar." },
      { t: "Cookies und lokaler Speicher", b: "GaimTime nutzt den lokalen Speicher für die Sitzung. Keine Werbe-Cookies." },
    ],
  },
  it: {
    cgv_title: "Termini e Condizioni",
    legal_title: "Note Legali",
    updated: "Ultimo aggiornamento: luglio 2026. Documento tipo da far validare da un professionista legale.",
    cgv: [
      { t: "1. Oggetto", b: "Questi termini regolano la vendita dei servizi GaimTime, un'app web per comprimere il tempo di lavoro." },
      { t: "2. Offerte e prezzi", b: "Accesso a vita: pagamento unico di 4,99 € IVA incl. GaimTime Coach & Compagno: 9,99 €/mese IVA incl. Prezzi con IVA 20%." },
      { t: "3. Pagamento", b: "Pagamenti protetti da Stripe. Nessun dato bancario memorizzato. Una fattura PDF è fornita dopo ogni pagamento." },
      { t: "4. Diritto di recesso", b: "L'accesso immediato al servizio digitale dopo il pagamento comporta la rinuncia al diritto di recesso di 14 giorni." },
      { t: "5. Disdetta", b: "L'abbonamento mensile è disdicibile in qualsiasi momento; termina al termine del periodo in corso, senza rimborso del mese iniziato." },
      { t: "6. Contatto", b: `Per qualsiasi domanda: ${CONTACT}.` },
    ],
    legal: [
      { t: "Editore", b: `Il servizio GaimTime è edito dal suo gestore. Contatto: ${CONTACT}.` },
      { t: "Hosting", b: "L'app è ospitata su infrastruttura cloud sicura (database MongoDB e archiviazione oggetti)." },
      { t: "Proprietà intellettuale", b: "Marchio GaimTime, logo, design e codice sono protetti. Vietata la riproduzione non autorizzata." },
      { t: "Dati personali (GDPR)", b: `I tuoi dati servono solo a fornire il servizio e personalizzare il coach. Diritti di accesso, rettifica e cancellazione via ${CONTACT}. Mai rivenduti.` },
      { t: "Notifiche", b: "Le notifiche push (promemoria di fine giornata) sono inviate solo col tuo consenso e disattivabili in qualsiasi momento." },
      { t: "Cookie e archiviazione locale", b: "GaimTime usa l'archiviazione locale per la sessione. Nessun cookie pubblicitario." },
    ],
  },
  pt: {
    cgv_title: "Termos e Condições",
    legal_title: "Aviso Legal",
    updated: "Última atualização: julho de 2026. Documento modelo a validar por um profissional jurídico.",
    cgv: [
      { t: "1. Objeto", b: "Estes termos regem a venda dos serviços GaimTime, um app web para comprimir o tempo de trabalho." },
      { t: "2. Ofertas e preços", b: "Acesso vitalício: pagamento único de 4,99 € c/ impostos. GaimTime Coach & Companheiro: 9,99 €/mês. Preços com IVA de 20%." },
      { t: "3. Pagamento", b: "Pagamentos protegidos pela Stripe. Nenhum dado bancário é armazenado. Uma fatura PDF é fornecida após cada pagamento." },
      { t: "4. Direito de retratação", b: "O acesso imediato ao serviço digital após o pagamento implica renúncia ao direito de retratação de 14 dias." },
      { t: "5. Cancelamento", b: "A assinatura mensal pode ser cancelada a qualquer momento; termina no fim do período em curso, sem reembolso do mês iniciado." },
      { t: "6. Contato", b: `Para qualquer dúvida: ${CONTACT}.` },
    ],
    legal: [
      { t: "Editor", b: `O serviço GaimTime é editado pelo seu operador. Contato: ${CONTACT}.` },
      { t: "Hospedagem", b: "O app é hospedado em infraestrutura cloud segura (base MongoDB e armazenamento de objetos)." },
      { t: "Propriedade intelectual", b: "A marca GaimTime, o logo, o design e o código são protegidos. Proibida a reprodução não autorizada." },
      { t: "Dados pessoais (RGPD)", b: `Seus dados servem apenas para prestar o serviço e personalizar o coach. Direitos de acesso, retificação e exclusão via ${CONTACT}. Nunca revendidos.` },
      { t: "Notificações", b: "As notificações push (lembretes de fim de dia) são enviadas apenas com seu consentimento e podem ser desativadas." },
      { t: "Cookies e armazenamento local", b: "GaimTime usa o armazenamento local para a sessão. Sem cookies publicitários." },
    ],
  },
  ru: {
    cgv_title: "Условия и положения",
    legal_title: "Правовая информация",
    updated: "Последнее обновление: июль 2026. Типовой документ, требующий проверки юристом.",
    cgv: [
      { t: "1. Предмет", b: "Настоящие условия регулируют продажу услуг GaimTime — веб-приложения для сжатия рабочего времени." },
      { t: "2. Предложения и цены", b: "Пожизненный доступ: разовый платёж 4,99 € с НДС. GaimTime Коуч и Компаньон: 9,99 €/мес. Цены с НДС 20%." },
      { t: "3. Оплата", b: "Платежи защищены Stripe. Банковские данные не хранятся. После каждой оплаты предоставляется PDF-счёт." },
      { t: "4. Право на отказ", b: "Немедленный доступ к цифровой услуге после оплаты означает отказ от 14-дневного права на возврат." },
      { t: "5. Отмена", b: "Ежемесячную подписку можно отменить в любой момент; она завершается в конце текущего периода без возврата за начатый месяц." },
      { t: "6. Контакт", b: `По любым вопросам: ${CONTACT}.` },
    ],
    legal: [
      { t: "Издатель", b: `Сервис GaimTime издаётся его оператором. Контакт: ${CONTACT}.` },
      { t: "Хостинг", b: "Приложение размещено на защищённой облачной инфраструктуре (база MongoDB и объектное хранилище)." },
      { t: "Интеллектуальная собственность", b: "Бренд GaimTime, логотип, дизайн и код защищены. Несанкционированное воспроизведение запрещено." },
      { t: "Персональные данные (GDPR)", b: `Ваши данные используются только для предоставления услуги и персонализации коуча. Права доступа, исправления и удаления через ${CONTACT}. Не перепродаются.` },
      { t: "Уведомления", b: "Push-уведомления (напоминания в конце дня) отправляются только с вашего согласия и отключаются в любой момент." },
      { t: "Файлы cookie и локальное хранилище", b: "GaimTime использует локальное хранилище для сессии. Рекламных cookie нет." },
    ],
  },
  ar: {
    cgv_title: "الشروط والأحكام",
    legal_title: "إشعار قانوني",
    updated: "آخر تحديث: يوليو 2026. وثيقة نموذجية يجب مراجعتها من قبل مختص قانوني.",
    cgv: [
      { t: "1. الغرض", b: "تحكم هذه الشروط بيع خدمات GaimTime، تطبيق ويب لضغط وقت العمل." },
      { t: "2. العروض والأسعار", b: "وصول مدى الحياة: دفعة واحدة 4.99 € شاملة الضريبة. مدرب ورفيق GaimTime: 9.99 €/شهر. الأسعار شاملة ضريبة 20%." },
      { t: "3. الدفع", b: "المدفوعات مؤمّنة عبر Stripe. لا تُخزَّن بيانات بطاقات. تُقدَّم فاتورة PDF بعد كل دفعة." },
      { t: "4. حق الانسحاب", b: "الوصول الفوري للخدمة الرقمية بعد الدفع يعني التنازل عن حق الانسحاب لمدة 14 يوماً." },
      { t: "5. الإلغاء", b: "يمكن إلغاء الاشتراك الشهري في أي وقت؛ ينتهي بنهاية الفترة الحالية دون استرداد الشهر المبدوء." },
      { t: "6. التواصل", b: `لأي سؤال: ${CONTACT}.` },
    ],
    legal: [
      { t: "الناشر", b: `خدمة GaimTime يصدرها مشغّلها. التواصل: ${CONTACT}.` },
      { t: "الاستضافة", b: "التطبيق مستضاف على بنية سحابية آمنة (قاعدة MongoDB وتخزين كائنات)." },
      { t: "الملكية الفكرية", b: "علامة GaimTime والشعار والتصميم والكود محمية. يُمنع النسخ غير المصرح به." },
      { t: "البيانات الشخصية (GDPR)", b: `تُستخدم بياناتك فقط لتقديم الخدمة وتخصيص المدرب. حقوق الوصول والتصحيح والحذف عبر ${CONTACT}. لا تُباع أبداً.` },
      { t: "الإشعارات", b: "إشعارات الدفع (تذكيرات نهاية اليوم) تُرسَل بموافقتك فقط ويمكن تعطيلها في أي وقت." },
      { t: "ملفات تعريف الارتباط والتخزين المحلي", b: "يستخدم GaimTime التخزين المحلي للجلسة. لا كوكيز إعلانية." },
    ],
  },
  zh: {
    cgv_title: "条款与条件",
    legal_title: "法律声明",
    updated: "最后更新：2026年7月。模板文件，需由法律专业人士审核。",
    cgv: [
      { t: "1. 目的", b: "本条款规范 GaimTime 服务的销售，这是一款压缩工作时间的网页应用。" },
      { t: "2. 方案与价格", b: "终身访问：一次性支付 4.99 €（含税）。GaimTime 教练与伙伴：9.99 €/月。价格含 20% 增值税。" },
      { t: "3. 付款", b: "付款由 Stripe 保护。不存储银行卡数据。每次付款后提供 PDF 发票。" },
      { t: "4. 撤销权", b: "付款后立即访问数字服务即表示放弃 14 天撤销权。" },
      { t: "5. 取消", b: "月度订阅可随时取消；在当前周期结束时终止，已开始的月份不退款。" },
      { t: "6. 联系", b: `如有疑问：${CONTACT}。` },
    ],
    legal: [
      { t: "发布者", b: `GaimTime 服务由其运营者发布。联系：${CONTACT}。` },
      { t: "托管", b: "应用托管于安全的云基础设施（MongoDB 数据库与对象存储）。" },
      { t: "知识产权", b: "GaimTime 品牌、标志、设计与代码受保护。禁止未经授权的复制。" },
      { t: "个人数据（GDPR）", b: `您的数据仅用于提供服务和个性化教练。可通过 ${CONTACT} 行使访问、更正和删除权。绝不转售。` },
      { t: "通知", b: "推送通知（一天结束提醒）仅在您同意时发送，可随时关闭。" },
      { t: "Cookie 与本地存储", b: "GaimTime 使用本地存储保存会话。无广告 Cookie。" },
    ],
  },
  ja: {
    cgv_title: "利用規約",
    legal_title: "法的通知",
    updated: "最終更新：2026年7月。法律専門家による確認が必要なテンプレート文書です。",
    cgv: [
      { t: "1. 目的", b: "本規約は、労働時間を圧縮するウェブアプリ GaimTime のサービス販売を規定します。" },
      { t: "2. プランと価格", b: "生涯アクセス：一括 4.99 €（税込）。GaimTime コーチ＆コンパニオン：9.99 €/月。価格は20%の付加価値税込み。" },
      { t: "3. 支払い", b: "支払いは Stripe により保護されます。カード情報は保存されません。各支払い後に PDF 請求書を提供します。" },
      { t: "4. 撤回権", b: "支払い後のデジタルサービスへの即時アクセスは、14日間の撤回権の放棄を意味します。" },
      { t: "5. 解約", b: "月額サブスクはいつでも解約可能。現行期間の終了時に終了し、開始済みの月の返金はありません。" },
      { t: "6. お問い合わせ", b: `ご質問は：${CONTACT}。` },
    ],
    legal: [
      { t: "発行者", b: `GaimTime サービスは運営者により発行されます。連絡先：${CONTACT}。` },
      { t: "ホスティング", b: "アプリは安全なクラウド基盤（MongoDB データベースとオブジェクトストレージ）でホストされます。" },
      { t: "知的財産", b: "GaimTime ブランド、ロゴ、デザイン、コードは保護されています。無断複製は禁止です。" },
      { t: "個人データ（GDPR）", b: `データはサービス提供とコーチの個別化のみに使用します。アクセス・訂正・削除の権利は ${CONTACT} から。転売はしません。` },
      { t: "通知", b: "プッシュ通知（一日の終わりのリマインダー）は同意がある場合のみ送信し、いつでも無効化できます。" },
      { t: "Cookie とローカルストレージ", b: "GaimTime はセッションにローカルストレージを使用します。広告 Cookie はありません。" },
    ],
  },
};

export function getLegal(lang) {
  return legalContent[lang] || legalContent.en;
}
